import {memoize} from '@packages/utilities/memo';
import type {Gateway} from '../types';
import type {PageRecordType} from '@packages/systems/core/records/PageRecord';
import type {BindingContext} from '../primitives';

function findPageBindingContext(
  gateways: Gateway[],
  page: PageRecordType
): BindingContext | null {
  for (let gatewayIndex = 0; gatewayIndex < gateways.length; gatewayIndex++) {
    const gateway = gateways[gatewayIndex];
    // @ts-expect-error - TS18048 - 'gateway' is possibly 'undefined'.
    const matchingContext = gateway
      .getPageBindingContexts()
      .find((pageBindingContext) => {
        return pageBindingContext.matchPage(page);
      });

    if (matchingContext) {
      return matchingContext;
    }
  }
  return null;
}

export default memoize(findPageBindingContext);
